module.exports = __webpack_public_path__ + "static/opciones_de_vri_de_movimiento_lateral-29517ec9ec8344a09fa2fbb3c3130131.png";